import { createContext } from "react";

export type ProviderContextValue = {
    profileModel?: unknown;
    setProfileModel?: (v: unknown) => void;
    menuActive?: number;
    setMenuActive?: (v: number) => void;
    /** เพิ่มทุกครั้งที่ต้องการให้ header โหลด Report/Template credit ใหม่ */
    companyCreditsVersion?: number;
    refreshCompanyCredits?: () => void;
};

export const ProviderContext = createContext<ProviderContextValue>({});